module.exports = __webpack_public_path__ + "static/img/Alvin Mustafa-close.6189626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Alvin Mustafa-close.jpg
// module id = 4TgZ
// module chunks = 1